export const OPEN_STATE = 'ASSIGNED';
export const ACCEPTED_STATE = 'ACCEPTED';
export const REJECTED_STATE = 'REJECTED';
export const TIME_OUT = 'TIMED_OUT';

export const statusEnum = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  RESCHEDULED: 'RESCHEDULED',
  ACCEPTED: 'ACCEPTED',
  RESOLVED: 'RESOLVED',
  IGNORED: 'IGNORED',
  REJECTED: 'REJECTED',
  NOT_SERVICEABLE: 'NOT_SERVICEABLE',
  ASSIGNED: 'ASSIGNED',
  TIMED_OUT: 'TIMED_OUT',
  ACCEPTANCE_TIMED_OUT: 'ACCEPTANCE_TIMED_OUT',
  OTHER_ISSUES: 'OTHER_ISSUES',
  HAPPYCODE_PENDING: 'HAPPYCODE_PENDING',
  GENERATE_OTP: 'GENERATE OTP',
  GET_HAPPYCODE: 'GET HAPPYCODE',
};

export const selectAllCheckboxEnableStatus = [
  statusEnum.OPEN,
  statusEnum.ACCEPTED,
  statusEnum.REJECTED,
  statusEnum.RESCHEDULED,
  statusEnum.TIMED_OUT,
  statusEnum.ASSIGNED,
  statusEnum.IGNORED,
  statusEnum.ACCEPTANCE_TIMED_OUT,
  statusEnum.OTHER_ISSUES,
  statusEnum.HAPPYCODE_PENDING,
];

export const serviceFlowConstants = {
  UPDATE_SERVICE_FLOW_DATA_INTERVAL_TIME: 2 * 60 * 1000,
  UPDATE_SERVICE_LIST_DATA_INTERVAL_TIME: 2 * 60 * 1000,
  DEBOUNCE_THRESHOLD: 800,
  // UPDATE_SERVICE_FLOW_DATA_INTERVAL_TIME: 5000,
  // UPDATE_SERVICE_LIST_DATA_INTERVAL_TIME: 5000
};

export const toastMessages = {
  rescheduleReasonFailure:
    'Unable to fetch reschedule reasons. Please try again later.',
  defaultErrorMsg: 'Something went wrong. Please try again later.',
  rescheduleSuccessMsg: 'Request rescheduled successfully.',
  copyClipboard: 'copied successfully.',
  copyClipboardErrorMsg: 'Sorry! not able to copy.',
};

export const selectPlaceHolder = 'Choose reason';
export const defaultToastMsg = { status: 'SUCCESS', msg: '' };

export const CLOSED_STATUS = 'closed';
export const mapStyle = {
  height: 'calc(100% - 185px)',
  top: '185px',
};
export const REQUEST_TYPE_FASTTRACK = 'fasttrack_service';
export const REQUEST_TYPE_DIY_SERVICE = 'diy_service';

export const requestTypeConstant = {
  DIY_SERVICE: 'diy_service',
  FAST_TRACK_SERVICE: 'fasttrack_service',
  CHANNEL_PARTNER_DEVICE_DEPLOYMENT: 'channel_partner_device_deployment',
  BANK_CHANNEL_PARTNER_DEVICE_DEPLOYMENT:
    'bank_channel_partner_device_deployment',
  CREDIT_MATE: 'cm',
  LENDING_CPV: 'lending_cpv',
};
export const ENTER_THE_REASON = 'Enter the Reason';
export const REMARK_MAX_LENGTH = 128;
export const UPDATE_REMARK = 'Update Remark';
export const AMS_MIN_APP_VERSION = '6.9.9';
